if (window._subiz_init_2094850928430) throw new Error('subiz have already initialized')
window._subiz_init_2094850928430 = true
const VERSION = require('./detect_version.js')()
if (!VERSION) throw new Error('subiz cannot detect version')

import store from '@sb/store'
const sb = require('@sb/util')
var axios = require('axios')
const config = require('@sb/config')

// JSAPI
const apiV4 = {}
// INCOMPATIBLE with v2: getVisitorId, getInfo
// v2 backward compatible
apiV4.setInfo = info => {
	if (!info) return
	var attributes = []
	if (info.name) attributes.push({key: 'fullname', text: info.name})
	if (info.email) attributes.push({key: 'emails', text: info.email})
	if (info.phone) attributes.push({key: 'phones', text: info.phone})
	if (attributes.length === 0) return
	apiV4.updateUserAttributes(attributes)
}

apiV4.setAccount = id => store.init(id)
apiV4._setAccount = apiV4.setAccount // deprecated
apiV4.setPosition = position => {}
apiV4.updateUserAttributes = async attributes => {
	await store.setUser({attributes})
	return sb.cloneDeep(store.user.attributes)
}

apiV4.getUserAttributes = async () => {
	await store.readyGate.entry()
	return sb.cloneDeep(sb.get(store.user, 'attributes', []))
}

import controller from './views/controller.js'
apiV4.expandWidget = (view, convo) => controller.showWidget(view, convo)
apiV4.shrinkWidget = () => controller.hideWidget()
apiV4.deleteUser = apiV4.forgetMe // deprecated
apiV4.showWidget = (view, convo) => controller.showWidget(view, convo)
apiV4.hideWidget = () => controller.hideWidget()
apiV4.showChatButton = () => false
apiV4.showButton = apiV4.showChatButton // deprecated
apiV4.hideChatButton = () => false
apiV4.showOfflineForm = () => controller.showOfflineForm()
apiV4.showPrechatForm = () => controller.showPrechatForm()
apiV4.showConvo = id => controller.showConvo(id)

const noop = () => {}
apiV4.askPushNotification = noop
apiV4.askInfo = noop
apiV4.askFeedback = noop
apiV4.showProduct = noop
apiV4.version = () => '4.239'
apiV4.preview = () => store.preview()
apiV4.upsertSetting = setting => {
	var usersetting = JSON.parse(JSON.stringify(store.userSetting))
	var accsetting = Object.assign({}, JSON.parse(JSON.stringify(store.accountSetting)), setting)
	usersetting.account_setting = accsetting || {}
	store.setSetting(usersetting)
	return usersetting
}
apiV4.setSetting = setting => store.setSetting(setting)
apiV4.getSetting = () => {
	var usersetting = JSON.parse(JSON.stringify(store.userSetting))
	var accsetting = JSON.parse(JSON.stringify(store.accountSetting))
	usersetting.account_setting = accsetting || {}
	return usersetting
}

apiV4.sendWs = async event => {
	await store.readyGate.entry()
	store.onWs(event)
}

apiV4.setCss = css => store.setCss(css)

apiV4.__setConvos = async convos => {
	await store.readyGate.entry()
	store._setConvos(convos)
}

apiV4.setLanguage = async (code, data) => {
	if (!sb.isValidLanguageCode(code)) return
	await store.readyGate.entry()
	await store.setLanguage(code, '', data)
}

function callV2(args) {
	args = sb.map(args, ag => ag)

	if (!Array.isArray(args)) return
	if (args.length < 1) return
	var method = args.shift()

	if (typeof apiV4[method] !== 'function') return
	return apiV4[method](...args)
}


function addScript (src) {
	var $script=document.createElement("script");
	$script.type="text/javascript";
	$script.async=true;
	$script.src= src
	document.body.appendChild($script)
}
const v3loaderjs = "https://storage.googleapis.com/public-gcs.subiz-cdn.com/widget-v4/public/v3_loader_2.js"
async function init() {
	// backward compatible api
	if (VERSION === '1' || VERSION === '2') {
		let v3accid = window.subiz_account_id // v3 1.0
		if (!v3accid) {
			// v3 2.0
			// lookup accid in window._sbzq.push(["_setAccount", 11177]); commands
			let queue = window._sbzq || []
			if (!Array.isArray(queue)) queue = []
			queue.forEach(item => {
				if (item[0] === '_setAccount') v3accid = item[1]
			})
		}

		console.log("GOT V3", v3accid)
		// find account v4 id
		let v4accid
		try {
			// will be remove in the future
			// use v3 widget
			let response = await axios.get(config.ApiURL + '/__link?id=' + v3accid)
			v4accid = sb.get(response, 'data.account_id')
			if (!v4accid) return addScript(v3loaderjs)
		} catch (e) {
			console.log(e)
			return addScript(v3loaderjs)
		}

		// converted to v4
		window.subiz_account_id = v4accid
		let queue = window._sbzq || []
		if (!Array.isArray(queue)) queue = []
		queue.forEach(item => {
			if (item[0] === '_setAccount') item[1] = v4accid
		})
	}

	if (VERSION === '1') apiV4._setAccount(window.subiz_account_id)
	if (VERSION === '2' || VERSION == '4.1') {
		let queue = window._sbzq || []
		if (!Array.isArray(queue)) queue = []
		window._sbzq = {push: callV2}
		queue.forEach(i => callV2(i))
	}

	if (VERSION === '4.2') {
		let queue = window.subiz.q || []
		window.subiz = function() {
			// do not convert to arrow function, arguments will be null
			return callV2(arguments)
		}
		queue.forEach(i => callV2(i))
	}

	await store.readyGate.entry()
	store.track()

	controller.mount()
	// require('./fcm.js').default()

	require('./campaign.js').default()
}
init()
